import type IndustryAverageByCompanyResponse from '@/components/IndustryAverages/interfaces/api/response/IndustryAverageByCompanyResponse';
import { getIndustryCompany } from '@simplywallst/services';
import type { QueryFunctionContext } from '@tanstack/react-query';

export function getQueryKey(
  uniqueSymbol?: string,
  threshold?: number
): [string, string, string] {
  return ['COMPANY_INDUSTRY_AVG', uniqueSymbol || '', `${threshold || 20}`];
}

export const queryFn = async ({
  queryKey: [_keyof, uniqueSymbol, threshold],
}: QueryFunctionContext<
  [string, string, string]
>): Promise<IndustryAverageByCompanyResponse> => {
  try {
    const response = await getIndustryCompany({
      companyIdentifier: `${uniqueSymbol}?threshold=${threshold}&name[]=pe&name[]=price_to_sales&name[]=pb`,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
